import React from "react";
// Material imports
import makeStyles from "@material-ui/core/styles/makeStyles"; // Limitless imports

import ExpertDialogueWrapper from "../expert-dialogue-wrapper/ExpertDialogueWrapper";
var useStyles = makeStyles(function (theme) {
  var _theme$palette$dialog, _theme$palette$dialog2, _theme$palette$dialog3;

  var borderRadius = (_theme$palette$dialog = (_theme$palette$dialog2 = theme.palette.dialogues) === null || _theme$palette$dialog2 === void 0 ? void 0 : (_theme$palette$dialog3 = _theme$palette$dialog2.expert) === null || _theme$palette$dialog3 === void 0 ? void 0 : _theme$palette$dialog3.borderRadius) !== null && _theme$palette$dialog !== void 0 ? _theme$palette$dialog : 12;
  return {
    extraPaddingListItem: {
      display: "flex",
      marginLeft: 5,
      borderRadius: borderRadius,
      padding: 10
    },
    loader: {
      textAlign: "center"
    },
    loaderSpan: {
      display: "inline-block",
      verticalAlign: "middle",
      width: 12,
      height: 12,
      borderRadius: 50,
      animation: "$llm-loader 0.9s infinite alternate",
      margin: 5,
      "&:nth-of-type(2)": {
        animationDelay: "0.3s"
      },
      "&:nth-of-type(3)": {
        animationDelay: "0.6s"
      }
    },
    "@keyframes llm-loader": {
      "0%": {
        opacity: "0.9"
      },
      "100%": {
        opacity: "0.1"
      }
    }
  };
});

var TypingIndicator = function TypingIndicator(_ref) {
  var claimer = _ref.claimer,
      message = _ref.message;
  var classes = useStyles();
  var expertInfo = null;

  if (message.claimedBy) {
    expertInfo = message.expertAuthors[message.claimedBy];
  }

  return /*#__PURE__*/React.createElement(ExpertDialogueWrapper, {
    shouldAnimate: true,
    author: claimer,
    expertInfo: expertInfo
  }, function (expertClasses) {
    return /*#__PURE__*/React.createElement("div", {
      className: "".concat(classes.extraPaddingListItem, " ").concat(expertClasses.expertBackground)
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        paddingLeft: 5
      }
    }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: classes.loader
    }, /*#__PURE__*/React.createElement("span", {
      className: "".concat(classes.loaderSpan, " ").concat(expertClasses.expertTyping)
    }), /*#__PURE__*/React.createElement("span", {
      className: "".concat(classes.loaderSpan, " ").concat(expertClasses.expertTyping)
    }), /*#__PURE__*/React.createElement("span", {
      className: "".concat(classes.loaderSpan, " ").concat(expertClasses.expertTyping)
    }))));
  });
};

export default TypingIndicator;